import dayjs from 'dayjs';

/** Publicado nos últimos 7 dias (alinhado à lista Atualizados Recentes). */
export function isNewChapterPublished(dateVal?: string | null): boolean {
    if (!dateVal) return false;
    const capDate = dayjs(dateVal);
    const diff = dayjs().diff(capDate, 'hour');
    return diff <= 168 && diff >= 0;
}

/** Campos comuns da API para data de publicação do capítulo. */
export function getChapterPublishDateString(c: any): string | undefined {
    const v =
        c?.lancado_em ??
        c?.cap_lancado_em ??
        c?.criado_em ??
        c?.cap_criado_em ??
        c?.criada_em ??
        c?.data ??
        c?.publicado_em;
    if (v == null) return undefined;
    const s = String(v).trim();
    return s === '' ? undefined : s;
}

export function NovoCapTag() {
    return (
        <span className="shrink-0 rounded px-1.5 py-0.5 text-[8px] font-black uppercase tracking-tighter bg-green-600 text-white shadow-sm border border-green-400/50">
            Novo
        </span>
    );
}
